import React from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [CategoryCode, setCategoryCode] = React.useState(FetchData.meta.category_code)
  const [FeaturedImage, setFeaturedImage] = React.useState(FetchData.meta.featured_image)
  const [CategoryType, setCategoryType] = React.useState(FetchData.meta.category_type)
  const [WhatsappGroup, setWhatsappGroup] = React.useState(FetchData.meta.whatsapp_group)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const type_array = {
    "korean": "Korean",
    "nasu": "nasu",
    "sakhaadhikrit": "sakhaadhikrit",
  }
  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "featured_image": FeaturedImage,
        "category_code": CategoryCode,
        "category_type": CategoryType,
        "whatsapp_group": WhatsappGroup
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_category)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Category Added Successfully")
          history.push(`${slugs.category_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_category, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Category Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Category Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Category Code</td>
                <td className="col-6">
                  <input className="input-common"
                    value={CategoryCode} placeholder="Category Code"
                    onChange={(event) => { setCategoryCode(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Featured Image</td>
                <td className="col-6">
                  <ImageUpload
                    ImageUrl={FeaturedImage}
                    setImageUrl={setFeaturedImage}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Whatsapp Group</td>
                <td className="col-6">
                  <input className="input-common"
                    value={WhatsappGroup} placeholder="Whatsapp Group"
                    onChange={(event) => { setWhatsappGroup(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Category Type</td>
                <td className="col-6">
                  <CustomButton setData={setCategoryType} Data={CategoryType} DataValue={"Feedback"} />
                  <CustomButton setData={setCategoryType} Data={CategoryType} DataValue={"Beginner"} />
                  <CustomButton setData={setCategoryType} Data={CategoryType} DataValue={"Intermediate"} />
                  <CustomButton setData={setCategoryType} Data={CategoryType} DataValue={"Advanced"} />
                  <CustomButton setData={setCategoryType} Data={CategoryType} DataValue={"Special"} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Category
              </div>
            </div>
          </div>
        </div>
      </div>
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
    </div>
  )

}